import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { intlPolyfills } from "@faire/web--source/common/localization/polyfill";

export const initializePolyfill = async () => {
  const polyfills: Promise<unknown>[] = [];
  const _window = getWindow();
  if (
    _window &&
    !(
      "IntersectionObserver" in _window &&
      "IntersectionObserverEntry" in _window &&
      "intersectionRatio" in _window.IntersectionObserverEntry.prototype
    )
  ) {
    polyfills.push(
      import(
        /* webpackChunkName: "intersection-observer" */ "intersection-observer"
      )
    );
  }

  polyfills.push(intlPolyfills());

  // Wait for all promises together rather than waiting for one to finish before fetching the next
  await Promise.all(polyfills);
};
